import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './shared/layout/app-layouts/auth-layout.component';
var ɵ0 = { pageTitle: "Login" }, ɵ1 = { pageTitle: "Home" }, ɵ2 = { pageTitle: "eGOV" }, ɵ3 = { pageTitle: "Auth" };
var routes = [
    {
        path: '',
        loadChildren: './features/auth/login/login.module#LoginModule',
        data: ɵ0
    },
    {
        path: 'main',
        loadChildren: './features/main/main.module#MainModule',
        data: ɵ1
    },
    {
        path: 'egov/callback',
        loadChildren: './features/auth/eGOV-callback/eGOV-callback.module#eGOVCallbackModule',
        data: ɵ2
    },
    // {
    //   path: "",
    //   component: MainLayoutComponent,
    //   children: [
    //     {
    //       path: "",
    //       redirectTo: "home",
    //       pathMatch: "full"
    //     },
    //     {
    //       path: "home",
    //       loadChildren: "./features/home/home.module#HomeModule"
    //     }
    //   ]
    // },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        loadChildren: './features/auth/auth.module#AuthModule',
        data: ɵ3
    },
    //the below enables adhoc search. for now it is not needed
    // {
    //   path: "guest",
    //   loadChildren: "./features/splash/splash.module#SplashModule"
    // },
    { path: '**', redirectTo: 'miscellaneous/error404' }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
